if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.prevButton = this.querySelector('[data-product-modal-prev]');
      this.nextButton = this.querySelector('[data-product-modal-next]');

      this.onPreviousMedia = this.onPreviousMedia.bind(this);
      this.onNextMedia = this.onNextMedia.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.stopPointerEvent = this.stopPointerEvent.bind(this);

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onPreviousMedia);
        this.prevButton.addEventListener('pointerup', this.stopPointerEvent);
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onNextMedia);
        this.nextButton.addEventListener('pointerup', this.stopPointerEvent);
      }

      this.addEventListener('keydown', this.onKeyDown);
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    getMediaItems() {
      return Array.from(this.querySelectorAll('[data-media-id]'));
    }

    getActiveMediaItem() {
      const openedMediaId = this.openedBy?.getAttribute('data-media-id');

      if (openedMediaId) {
        const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`);
        if (activeMedia) return activeMedia;
      }

      return this.querySelector('[data-media-id].active') || this.getMediaItems()[0];
    }

    setActiveMediaItem(activeMedia) {
      if (!activeMedia) return;

      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('active');
      });

      activeMedia.classList.add('active');

      const container = this.querySelector('[role="document"]');
      activeMedia.scrollIntoView();

      if (container && activeMedia.width) {
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }

      if (typeof activeMedia.loadContent === 'function') {
        activeMedia.loadContent();
      }
    }

    showActiveMedia() {
      this.setActiveMediaItem(this.getActiveMediaItem());
    }

    onPreviousMedia(event) {
      event.preventDefault();
      event.stopPropagation();
      this.showMediaByOffset(-1);
    }

    onNextMedia(event) {
      event.preventDefault();
      event.stopPropagation();
      this.showMediaByOffset(1);
    }

    onKeyDown(event) {
      if (!this.hasAttribute('open')) return;
      if (this.isTypingTarget(event.target)) return;

      if (event.code === 'ArrowLeft') {
        event.preventDefault();
        this.showMediaByOffset(-1);
      }

      if (event.code === 'ArrowRight') {
        event.preventDefault();
        this.showMediaByOffset(1);
      }
    }

    showMediaByOffset(direction) {
      const mediaItems = this.getMediaItems();
      if (!mediaItems.length) return;

      const currentMedia = this.getActiveMediaItem();
      const currentIndex = Math.max(mediaItems.indexOf(currentMedia), 0);
      const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;

      this.setActiveMediaItem(mediaItems[nextIndex]);
    }

    isTypingTarget(target) {
      if (!(target instanceof Element)) return false;
      return Boolean(
        target.closest('input, textarea, select, [contenteditable="true"]') ||
          target.isContentEditable
      );
    }

    stopPointerEvent(event) {
      event.stopPropagation();
    }
  });
}
